import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services';
import { AUTH_ROUTES } from '../tokens';

/**
 * For protected routes: redirects to TFA verification if 2FA is pending.
 * Should run after authGuard, before questionnaireGuard.
 */
export const tfaGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const routes = inject(AUTH_ROUTES);

  const tfa = storage.getItem('tfa');
  console.log('[tfaGuard]', { tfa });
  if (tfa === 'needToCheck' && routes.tfaUrl) {
    console.log('[tfaGuard] → redirect to tfa-verification');
    return inject(Router).parseUrl(routes.tfaUrl);
  }

  console.log('[tfaGuard] → pass');
  return true;
};

/**
 * For protected routes: redirects to 2FA setup page on first login when TFA is not enabled.
 * Should run after tfaGuard, before questionnaireGuard.
 */
export const tfaSetupGuard: CanActivateFn = () => {
  const storage = inject(StorageService);
  const routes = inject(AUTH_ROUTES);

  const isFirstLogin = storage.getItem('firstLogin') === 'true';
  const tfaEnabled = storage.getItem('TFAEnabled') === 'true';
  console.log('[tfaSetupGuard]', { isFirstLogin, tfaEnabled });

  if (isFirstLogin && !tfaEnabled && routes.tfaSetupUrl) {
    console.log('[tfaSetupGuard] → redirect to setup-tfa');
    return inject(Router).parseUrl(routes.tfaSetupUrl);
  }

  console.log('[tfaSetupGuard] → pass');
  return true;
};

/**
 * For the TFA page itself: only allows access when 2FA is actually pending.
 */
export const tfaAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const routes = inject(AUTH_ROUTES);

  const isAuthenticated = storage.getItem('isLoggedIn') === 'true';
  const needToCheckTfa = storage.getItem('tfa') === 'needToCheck';
  if (!isAuthenticated) {
    return router.parseUrl(routes.loginUrl);
  }

  if (!needToCheckTfa) {
    return router.parseUrl(routes.homeUrl);
  }

  return true;
};
